module.exports = __webpack_public_path__ + "img/loginLogo.cc2a79f2.png";